import { TagsOrderBy } from 'common/types/globalTypes';
import { OrderDirection, SortOrder } from 'common/utils/commonTypes';

type OrderLookup = {
  [direction in OrderDirection]: TagsOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'name',
    {
      [OrderDirection.ASC]: ['NAME_ASC'],
      [OrderDirection.DESC]: ['NAME_DESC'],
    },
  ],
  [
    'description',
    {
      [OrderDirection.ASC]: ['DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['DESCRIPTION_DESC'],
    },
  ],
  [
    'badgeName',
    {
      [OrderDirection.ASC]: ['BADGE_NAME_ASC'],
      [OrderDirection.DESC]: ['BADGE_NAME_DESC'],
    },
  ],
  [
    'badgeColor',
    {
      [OrderDirection.ASC]: ['BADGE_COLOR_ASC'],
      [OrderDirection.DESC]: ['BADGE_COLOR_DESC'],
    },
  ],
  [
    'isPrivate',
    {
      [OrderDirection.ASC]: ['IS_PRIVATE_ASC'],
      [OrderDirection.DESC]: ['IS_PRIVATE_DESC'],
    },
  ],
  [
    'isMonitored',
    {
      [OrderDirection.ASC]: ['_IS_MODIFIED_ASC'],
      [OrderDirection.DESC]: ['IS_MONITORED_DESC'],
    },
  ],
  [
    '_isSystemGenerated',
    {
      [OrderDirection.ASC]: ['_IS_SYSTEM_GENERATED_ASC'],
      [OrderDirection.DESC]: ['_IS_SYSTEM_GENERATED_DESC'],
    },
  ],
  [
    '_isActive',
    {
      [OrderDirection.ASC]: ['_IS_ACTIVE_ASC'],
      [OrderDirection.DESC]: ['_IS_ACTIVE_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: TagsOrderBy []= ['NAME_ASC'];
  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return Array.from(new Set([...(orderBy ? orderBy : []), ...orderByArray]));
};

export const badgeColor = (badgeColor: string) => {
  switch (badgeColor) {
    case 'YELLOW':
      return '#ffd000';
    case 'RED':
      return '#d14249';
    case 'GREEN':
      return '#29a849';
    case 'CYAN':
      return '#11e9e9';
    case 'MAGENTA':
      return '#c658ca';
    default:
      return '#0078d4';
  }
};
